module.exports = __webpack_public_path__ + "static/media/Ikonka_dlya_prilozhenia_monetizatsia.5ac1dd1c.png";